import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 设备列表
export const getPile = (params) => { return req("get", "/admin/pile?"+getHttpParams(params)) };
//新增
export const addPile = (params) => { return req("get", "/admin/pile/create?"+getHttpParams(params)) };

export const updatePile = (id, params) => { return req("patch", "/admin/pile/"+id+'?'+getHttpParams(params)) };

export const deletePile = (id) => { return req("delete", "/admin/pile/"+id) };

export const get_pile_by_station = (params) => { return req("get", "/admin/get_pile_by_station?"+getHttpParams(params)) };

export const reStartPile = (params) => { return req("get", "/admin/reStartPile?"+getHttpParams(params)) };



// WEBPACK FOOTER //
// ./src/api/pile.js